import {axios, HOST, config} from './settiing';

export default {
  getEvStationLocation(data){
    return axios.post(`${HOST}/resource/evStationLocation`, data, config);
  },
}